import styled from "@emotion/styled";
import isPropValid from '@emotion/is-prop-valid';
import { mq } from "@styles/helpers";
import { Devices } from "@styles/tokens";

export const FilterBar = styled('div', {
    shouldForwardProp: (prop) => isPropValid(prop) && prop !== 'display',
})<{display?:boolean}>`
    width:100%;
    display:${props => props.display?"flex":"none"};
    align-items: center;
    gap:1.5rem;
    z-index: 1;
    position: relative;
    padding:0.7rem 1rem;
    background:#fff;
    border-radius: 5px;
    box-shadow: 0 0 3px rgba(0,0,0,0.25);
    margin-top: 1rem;
    min-height: 34px;
`;